class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close.modal__close-button').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    
    if (document.querySelector('.overlay')) document.querySelector('.overlay').addEventListener('click', event => this.close());
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.querySelector("body").classList.add('active-cart');
    
    if (document.querySelector('.overlay')) {
      document.querySelector('.overlay').style.display = 'block';
    }

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
    
    document.querySelectorAll('cart-notification [name="remove-line-item"]').forEach(element => {
      element.addEventListener('click', event => {
        fetch(
          '/cart/change.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(
              {
                'line': element.closest('[id^=cart-notification-product]').dataset.lineItemIndex,
                'quantity': 0,
                'sections': this.getSectionsToRender().map(section => section.id)
              }
            )
          })
          .then(response => response.json())
          .then(data     => {
            this.renderContents(data);
          }) 
          .catch(error => console.error(error));
      });
    });
    
    document.querySelectorAll('cart-notification quantity-input').forEach(element => {
      element.addEventListener('change', event => {
        const value            = event.srcElement.value;
        const cartNotification = document.querySelector('#shopify-section-header > cart-notification');
        
        if (value) {
          fetch(
            '/cart/change.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(
                {
                  'line': element.closest('[id^=cart-notification-product]').dataset.lineItemIndex,
                  'quantity': value,
                  'sections': this.getSectionsToRender().map(section => section.id)
                }
              )
            })
            .then(response => response.json())
            .then(data     => this.renderContents(data)) 
            .catch(error   => console.error(error));
        }
      });
    });
  }

  close() {
    this.notification.classList.remove('active');
    document.querySelector("body").classList.remove('active-cart');
    
    if (document.querySelector('.overlay')) {
      document.querySelector('.overlay').style.display = 'none';
    }

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, sections = parsedState.sections) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(sections[section.id], section.selector);
      }));
      
      const money = {
        divisor: 100,
        round:   2
      };
      let   discount = 0;
      const items_subtotal_price = parsedState.items_subtotal_price;
      const quantityChecker      = q => parsedState.items.some(element => element.quantity >= q);
      const divisor = quantityChecker(4) ? 15 : quantityChecker(2) ? 10 : 0;

      if (divisor) {
        discount = items_subtotal_price * (divisor / (100 * money.divisor));
      }
    
      let subtotalAfterDiscount = (items_subtotal_price / money.divisor) - discount;
      
      if (discount) {
        document.querySelector('#cart-notification-prices .subtotal-discount dd').innerText = `-\$${discount.toFixed(money.round)}`;
        document.querySelector('#cart-notification-prices .subtotal-discount').style.display = 'block';
      } else {
        document.querySelector('#cart-notification-prices .subtotal-discount').style.display = 'none';
      }

      document.querySelector('#cart-notification-prices .subtotal dd').innerText = `\$${subtotalAfterDiscount.toFixed(money.round)}`;
      
      const max        = parseFloat(document.querySelector('.cart-notification-wrapper progress').getAttribute('max'));
      const original   = parsedState.original_total_price / money.divisor;
      const difference = max - original;
      
      if (difference >= 0) {
        document.querySelector('.cart-notification-wrapper progress').value = original;
        document.querySelector('#freeShippingText .progress span').innerText = difference.toFixed(2);
        document.querySelector('#freeShippingText .progress').style.display = 'block';
        document.querySelector('.cart-notification-prices .shipping').style.display = 'flex';
        document.querySelector('#freeShippingText .achieved').style.display = 'none';
        document.querySelector('.cart-notification-prices .shipping dd').innerText = '+ $10.00';
      } else {
        document.querySelector('.cart-notification-wrapper progress').value = max;
        document.querySelector('#freeShippingText .progress').style.display = 'none'; 
        document.querySelector('#freeShippingText .achieved').style.display = 'block';
        document.querySelector('.cart-notification-prices .shipping').style.display = 'none';
        document.querySelector('.cart-notification-prices .shipping dd').innerText = '+ $0.00';
      }

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
